import {httpGetSpecialist, HttpGetSpecialistOptions} from '@/features/projects/specialists/http/specialists.http'
import {ReferringSpecialist} from '@/features/referring-specialists/types'
import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'

interface UseGetSpecialistOptions {
    urlParams: HttpGetSpecialistOptions['urlParams']
    options?: Omit<UseQueryOptions<ReferringSpecialist>, 'queryKey' | 'queryFn'>
}

export const useGetSpecialist = ({urlParams, options}: UseGetSpecialistOptions) => {
    return useQuery({
        queryKey: [QUERY_KEYS.SPECIALISTS, urlParams.id],
        queryFn: () => httpGetSpecialist({urlParams}),
        ...options
    })
}
